/*
 * Jira Ticket:
 * Created Date: Mon, 8th Jun 2020, 14:25:07 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getListRolesQuery = gql`
  query Roles {
    items: roles {
      role
      organisationId
      projectId
    }
  }
`;

export default async ({ client }) => {
  try {
    const result = await client.query({
      query: getListRolesQuery,
      variables: {},
      fetchPolicy: 'network-only',
    });
    await localStorage.setItem(
      'org_permissions',
      JSON.stringify(result.data.items)
    );
    result.data.total = result.data.items.length;
    return result;
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
